'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Header = require('./components/Header.Table');

var _Header2 = _interopRequireDefault(_Header);

var _Table = require('./components/Table.Table');

var _Table2 = _interopRequireDefault(_Table);

var _TableHeader = require('./components/TableHeader.Table');

var _TableHeader2 = _interopRequireDefault(_TableHeader);

var _TableHeaderColumn = require('./components/TableHeaderColumn.Table');

var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);

var _Row = require('./components/Row.Table');

var _Row2 = _interopRequireDefault(_Row);

var _Pagination = require('./components/Pagination.Table');

var _Pagination2 = _interopRequireDefault(_Pagination);

var _NotFound = require('./components/NotFound.Table');

var _NotFound2 = _interopRequireDefault(_NotFound);

var _Scroller = require('./components/Scroller.Table');

var _Scroller2 = _interopRequireDefault(_Scroller);

var _SortIcon = require('./components/SortIcon.Table');

var _SortIcon2 = _interopRequireDefault(_SortIcon);

var _Loader = require('./components/Loader.Table');

var _Loader2 = _interopRequireDefault(_Loader);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components


var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Table.__proto__ || Object.getPrototypeOf(Table)).call.apply(_ref, [this].concat(args))), _this), _this.portions = function () {
      return _this.props.columns.reduce(function (sum, c) {
        return sum + (c.span || 1);
      }, 0) || 1;
    }, _this.onSort = function (key) {
      var _this$props = _this.props,
          onSort = _this$props.onSort,
          sort = _this$props.sort;
      if (!onSort) return;
      if (!sort || sort.key !== key) return onSort({
        key: key,
        direction: 'asc'
      });
      if (sort.direction === 'desc') return onSort(null);
      return onSort({
        key: key,
        direction: 'desc'
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Table, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          title = _props.title,
          subtitle = _props.subtitle,
          search = _props.search,
          onSearch = _props.onSearch,
          columns = _props.columns,
          children = _props.children,
          infinite = _props.infinite,
          page = _props.page,
          pages = _props.pages,
          onPage = _props.onPage,
          noResultsLabel = _props.noResultsLabel,
          smallNoResultsLabel = _props.smallNoResultsLabel,
          height = _props.height,
          sort = _props.sort,
          onSort = _props.onSort,
          loading = _props.loading,
          noRadius = _props.noRadius,
          noBorder = _props.noBorder,
          headerItems = _props.headerItems,
          big = _props.big;
      var portions = this.portions();

      var rows = _react.Children.map(children(_Row2.default, portions, big), function (component) {
        return (0, _react.cloneElement)(component, {
          portions: portions,
          big: big
        });
      });

      return _react2.default.createElement('div', null, _react2.default.createElement(_Header2.default, {
        title: title,
        subtitle: subtitle,
        search: search,
        onSearch: onSearch,
        items: headerItems
      }), _react2.default.createElement(_Table2.default, {
        noRadius: noRadius,
        noBorder: noBorder
      }, _react2.default.createElement(_TableHeader2.default, {
        noRadius: noRadius
      }, columns.map(function (header) {
        return _react2.default.createElement(_TableHeaderColumn2.default, {
          portions: portions,
          key: header.key,
          pointer: header.sortable && onSort !== null,
          onClick: function onClick(e) {
            if (!header.sortable || !onSort) return;

            _this2.onSort(header.key);
          },
          largePadding: header.largePadding,
          span: header.span || 1,
          align: header.align
        }, sort !== null && sort.key === header.key && _react2.default.createElement(_SortIcon2.default, {
          icon: 'caret' + (sort.direction === 'asc' ? 'up' : 'down')
        }), header.label);
      })), loading && _react2.default.createElement(_Loader2.default, {
        small: smallNoResultsLabel
      }), !loading && _react2.default.createElement(_Scroller2.default, {
        height: height
      }, rows), !loading && (!rows || !rows.length) && _react2.default.createElement(_NotFound2.default, {
        small: smallNoResultsLabel
      }, noResultsLabel)), !infinite && onPage !== null && _react2.default.createElement(_Pagination2.default, {
        page: page,
        pages: pages,
        onChange: onPage,
        small: true
      }));
    }
  }]);

  return Table;
}(_react.Component);

Table.propTypes = {
  title: _propTypes2.default.string,
  subtitle: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  search: _propTypes2.default.string,
  onSearch: _propTypes2.default.func,
  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.node,
    noPadding: _propTypes2.default.bool,
    onSort: _propTypes2.default.func,
    largePadding: _propTypes2.default.bool,
    span: _propTypes2.default.number,
    align: _propTypes2.default.oneOf(['left', 'center', 'right'])
  })),
  infinite: _propTypes2.default.bool,
  height: _propTypes2.default.number,
  page: _propTypes2.default.number.isRequired,
  pages: _propTypes2.default.number.isRequired,
  onPage: _propTypes2.default.func,
  noResultsLabel: _propTypes2.default.string,
  smallNoResultsLabel: _propTypes2.default.bool,
  children: _propTypes2.default.func,
  onSort: _propTypes2.default.func,
  sort: _propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    direction: _propTypes2.default.oneOf(['asc', 'desc']).isRequired
  }),
  noRadius: _propTypes2.default.bool,
  noBorder: _propTypes2.default.bool,
  big: _propTypes2.default.bool,
  headerItems: _propTypes2.default.func
};
Table.defaultProps = {
  title: null,
  subtitle: null,
  loading: false,
  search: '',
  onSearch: null,
  infinite: true,
  height: 0,
  noResultsLabel: 'No results found',
  smallNoResultsLabel: false,
  page: 1,
  pages: 1,
  onPage: null,
  onSort: null,
  sort: null,
  noRadius: false,
  noBorder: false,
  big: false,
  columns: [],
  headerItems: function headerItems() {
    return null;
  }
};
exports.default = Table;